import React, {Fragment} from 'react';
import './index.scss'
import {InputNumber, Modal, Menu, Dropdown, message, Tag} from 'antd';
import {DownOutlined} from '@ant-design/icons';
import NP from "number-precision";
import IMG_Default from "../../assets/images/loading_bg_template.png";
import CommonUtil from "../../utils/common-util";
import ImgAdapt from "../../components/img-adapt";
import StorageUtil from "@utils/storage-util";
import {LocalConst} from "@utils/constant";
import {injectIntl} from'react-intl'
import DataConstant from "../../utils/data-constant";
import {CartFetch} from "../../services/service";
import CheckUtil from "../../utils/check-util";
import {connect} from "dva";
import classnames from "classnames";
import {Scrollbars} from "react-custom-scrollbars";
import RenderUtil from "../../utils/render-util";
import InitUtil from "../../utils/init-util";

@injectIntl
@connect(state => ({...state.appModel}))
class GoodsListAction extends React.PureComponent {
    constructor(props) {
        super(props);
        this.intl = props.intl;
        // 库存是否可以超售
        this.enableStockZero = !!StorageUtil.getItem(LocalConst.enableStockZero);
        //起订量
        this.enableMinCount = StorageUtil.getItem(LocalConst.enableMinCount);
        //限定量
        this.enableMaxCount = StorageUtil.getItem(LocalConst.enableMaxCount);
        //默认订货单位
        this.orderDefaultUnit = StorageUtil.getItem(LocalConst.orderDefaultUnit); //1:默认按基本单位订货;2:默认按最大辅助单位订货
        this.allowClientPrice = !StorageUtil.getItem(LocalConst.allowClientPrice);
        this.isLogin = CommonUtil.isLogin();
        // 价格精度
        this.priceScale = StorageUtil.getItem(LocalConst.priceScale);
        this.countScale = StorageUtil.getItem(LocalConst.countScale);
        this.companyTheme = StorageUtil.getItem(LocalConst.companyTheme);
        this.clientShowCubage = StorageUtil.getItem(LocalConst.clientShowCubage);
        this.currencySymbol = StorageUtil.getItem(LocalConst.currencySymbol) || '￥';
        this.inputNumberMin = 1;
        this.cartParams = [];
        switch (+this.countScale) {
            case 1:
                this.inputNumberMin = 0.1;
                break;
            case 2:
                this.inputNumberMin = 0.01;
                break;
        }
        this.state = {
            goods: {},
            currentProduct: {},
            addProductList: [],
            isShowAddProductList: false,
            isShowVideo: false,
            promotionInfo: {},
            specsValue: {},
            specsValueLvl: {},
        };
    }

    componentWillMount() {
        let goods = JSON.parse(JSON.stringify(this.props.goods));
        goods = this.formatGoods(goods);
        console.log('goods：', goods)
        this.currentUnit = {
            unit_id_: goods.unit_id_,
            unit_name_: goods.unit_name_,
            unit_text_: goods.unit_name_,
            scale_: 1,
            unit_price_: 'client_price_'
        };
        let multUnitList = [{...this.currentUnit}];
        multUnitList = multUnitList.concat(CommonUtil.stringToArr(goods.multi_unit_).extend_units_ || []);
        multUnitList.forEach((unit, index) => {
            unit.unit_id_ = +unit.unit_id_;
            unit.scale_ = +unit.scale_;
            if (index === 0) {
                unit.unit_price_key_ = 'unit_price_';
            } else if (index === 1) {
                unit.unit_price_key_ = 'unit2_price_';
            }
        });
        multUnitList = multUnitList.filter(item => item.unit_id_);
        // 默认辅助单位选取最大的
        if (this.orderDefaultUnit === 2) {
            for (let i = 0; i < multUnitList.length; i++) {
                if (multUnitList[i].scale_ > this.currentUnit.scale_) {
                    Object.assign(this.currentUnit, multUnitList[i]);
                }
            }
        }
        const usableUnitList = CommonUtil.handleMultiUnits(CommonUtil.stringToArr(goods.multi_unit_));
        if (!usableUnitList.length) {
            this.unitList = [{...this.currentUnit}];
        } else {
            this.unitList = [];
            usableUnitList.forEach(unitId => {
                multUnitList.forEach(unit => {
                    if (unitId === unit.unit_id_) {
                        this.unitList.push(unit);
                    }
                });
            });
            if (this.unitList.length === 1) {
                Object.assign(this.currentUnit, {...this.unitList[0]});
            } else {
                // 销售设置设置为最大辅助单位订货
                if (this.orderDefaultUnit === 2) {
                    const resultList = this.unitList.filter(unit => unit.unit_id_ === this.currentUnit.unit_id_);
                    if (!resultList.length) {
                        this.unitList.sort((a, b) => (a.scale_ - b.scale_));
                        Object.assign(this.currentUnit, {...this.unitList[1]});
                    }
                } else { // 销售设置设置为基本单位订货
                    if (CommonUtil.stringToArr(goods.multi_unit_).usable_[0] === 0) { // 可订货单位中没有基本单位,取最小辅助单位
                        this.unitList.sort((a, b) => (a.scale_ - b.scale_));
                        Object.assign(this.currentUnit, {...this.unitList[0]});
                    }
                }
            }
        }

        goods.mult_unit_ = this.unitList;
        if (goods.is_multi_unit_) {
            this.maxUnit = {...goods.mult_unit_[0]};
            goods.mult_unit_.forEach(unit => {
                if (unit.scale_ > this.maxUnit.scale_) {
                    Object.assign(this.maxUnit, unit);
                }
            });
        }
        console.log('mult_unit_：', goods.mult_unit_);
        goods.productList.forEach(product => {
            const unit = goods.mult_unit_.find(unit => +unit.unit_id_ === product.unit_id_) || {};
            product.clientPrice = CommonUtil.priceScale(product.client_price_);
            product.realPrice = product.clientPrice;
            product.enableStock = parseInt(NP.divide(product.house_enable_stock_, (unit.scale_ || 1)));
            product.number_scale_ = this.currentUnit.scale_;
            product.unit_id_ = this.currentUnit.unit_id_;
            product.unit_name_ = this.currentUnit.unit_name_;
            product.unit_text_ = this.currentUnit.unit_text_;
            product.cart_number_ = 0;
        });
        this.setState({
            goods: goods
        }, () => {
            const {goods} = this.state;
            if (this.isLogin && goods.putaway_) {
                this.getPromotionByGoodsId(goods);
            }
            if (goods.productList.length === 1 && !goods.is_multi_spec_) {
                this.defaultSingleSelect();
            }
        });
    }

    componentWillUnmount() {
        clearInterval(this.interval_);
    }

    // 格式化商品数据
    formatGoods = (goods) => {
        //处理商品标签信息
        if (goods.tag_ids_ && typeof goods.tag_ids_ === 'string') {
            goods.tag_ids_ = (goods.tag_ids_ ? goods.tag_ids_.split(",") : []);
        }
        if (goods.tag_names_ && typeof goods.tag_names_ === 'string') {
            goods.tag_names_ = (goods.tag_names_ ? goods.tag_names_.split(",") : []);
        }
        if (goods.tag_colors_ && typeof goods.tag_colors_ === 'string') {
            goods.tag_colors_ = (goods.tag_colors_ ? goods.tag_colors_.split(",") : []);
        }

        this.currentUnit = {
            unit_id_: +goods.unit_id_,
            unit_name_: goods.unit_name_,
            unit_text_: goods.unit_name_,
            scale_: 1,
            unit_price_key_: 'client_price_'
        };
        let multUnitList = [{...this.currentUnit}];
        multUnitList = multUnitList.concat(CommonUtil.stringToArr(goods.multi_unit_).extend_units_ || []);
        multUnitList.forEach((unit, index) => {
            unit.unit_id_ = +unit.unit_id_;
            unit.scale_ = +unit.scale_;
            if (index === 0) {
                unit.unit_price_key_ = 'unit_price_';
            } else if (index === 1) {
                unit.unit_price_key_ = 'unit2_price_';
            }
        });
        multUnitList = multUnitList.filter(item => item.unit_id_);
        // 默认辅助单位选取最大的
        if (this.orderDefaultUnit === 2) {
            for (let i = 0; i < multUnitList.length; i++) {
                if (multUnitList[i].scale_ > this.currentUnit.scale_) {
                    Object.assign(this.currentUnit, multUnitList[i]);
                }
            }
        }
        const usableUnitList = CommonUtil.handleMultiUnits(CommonUtil.stringToArr(goods.multi_unit_));
        if (!usableUnitList.length) {
            this.unitList = [{...this.currentUnit}];
        } else {
            this.unitList = [];
            usableUnitList.forEach(unitId => {
                multUnitList.forEach(unit => {
                    if (unitId === unit.unit_id_) {
                        this.unitList.push(unit);
                    }
                });
            });
            if (this.unitList.length === 1) {
                Object.assign(this.currentUnit, {...this.unitList[0]});
            } else {
                // 销售设置设置为最大辅助单位订货
                if (this.orderDefaultUnit === 2) {
                    const resultList = this.unitList.filter(unit => unit.unit_id_ === this.currentUnit.unit_id_);
                    if (!resultList.length) {
                        this.unitList.sort((a, b) => (a.scale_ - b.scale_));
                        Object.assign(this.currentUnit, {...this.unitList[1]});
                    }
                } else { // 销售设置设置为基本单位订货
                    if (CommonUtil.stringToArr(goods.multi_unit_).usable_[0] === 0) { // 可订货单位中没有基本单位,取最小辅助单位
                        this.unitList.sort((a, b) => (a.scale_ - b.scale_));
                        Object.assign(this.currentUnit, {...this.unitList[0]});
                    }
                }
            }
        }
        goods.mult_unit_ = this.unitList;

        if (goods.is_multi_spec_) {
            goods.spec_setting_ = CommonUtil.stringToObj(goods.spec_setting_);
            goods.spec_setting_.settings_.sort((a, b) => {
                return a.seq_ - b.seq_;
            })
        }

        goods.introduce_ = CommonUtil.stringToArr(goods.introduce_);
        goods.property_custom_json_ = CommonUtil.stringToArr(goods.property_custom_json_);
        // 商品参数
        if (!goods.propList) {
            goods.propList = [];
            goods.property_custom_json_.forEach(item => {
                if (item.is_show_) {
                    goods.propList.push({name_: item.name_, value_: item.value_})
                }
            });
        } else {
            goods.propList = goods.propList.filter(item => {
                return item.id_ && item.is_show_ || !item.id_
            })
        }
        return goods;
    };

    getPromotionByGoodsId = (goodsData) => {
        const getPromotion = new Promise((resolve, reject) => {
            CartFetch.getPromotionByGoodsId({goodsId: goodsData.id_}, (rs) => {
                if (rs.status === 1) {
                    let promotionList = [];
                    rs.data.forEach(item => {
                        goodsData.productList.forEach(product => {
                            if (item.product_id_ === product.id_) {
                                promotionList.push(item);
                                product.promotionType = item.type_;
                            }
                        })
                    });
                    resolve(promotionList)
                } else {
                    reject(rs.message)
                }
            })
        });

        const getPresalePromotion = new Promise((resolve, reject) => {
            CartFetch.getpresalePromotionByGoodsId({goodsId: goodsData.id_}, (rs) => {
                if (rs.status === 1) {
                    let promotionList = [];
                    rs.data.forEach(item => {
                        item.type_ = 4;
                        goodsData.productList.forEach(product => {
                            if (item.product_id_ === product.id_) {
                                product.realPrice = item.presale_price_;
                                product.promotionType = item.type_;
                                promotionList.push(item)
                            }
                        })
                    });
                    resolve(promotionList)
                } else {
                    reject(rs.message)
                }
            })
        });
        Promise.all([getPromotion, getPresalePromotion]).then((results) => {
            let promotionArr = [...results[0], ...results[1]];
            let promotionInfo = {};
            promotionArr.forEach(promotion => {
                promotionInfo = ({...promotionInfo, [promotion.product_id_]: {productPromotion: promotion}});
            });
            this.setState({
                promotionInfo: promotionInfo
            }, () => {
                if (!CheckUtil.isEmptyObject(this.state.promotionInfo) && !this.interval_) {
                    this.interval_ = window.setInterval(() => {
                            const {promotionInfo} = this.state;
                            for (let key in promotionInfo) {
                                const item = promotionInfo[key].productPromotion;
                                if (item.remaining_time_ > 0) {
                                    item.remaining_time_ = item.remaining_time_ - 1000;
                                }
                            }
                            this.setState({
                                promotionInfo: promotionInfo
                            })
                        }, 1000
                    );
                }
            });
        }).catch((error) => {
            console.log(error)
        });
    };

    // 单规格商品默认选中
    defaultSingleSelect = () => {
        const {goods} = this.state;
        this.selectProduct(goods.productList[0]);
    };

    // 修改购物车数量
    changeNumber = (num, product) => {
        const {pdList, currentProduct, addProductList, goods, promotionInfo} = this.state;
        if (!this.isLogin) {
            this.props.onCancel();
            RenderUtil.renderLoginModal.call(this.props.intl);
            return;
        }
        if (Object.keys(currentProduct).length === 0) {
            message.info(this.intl.messages['QXZGG'] || '请选择规格！');
            return
        }
        const editProduct = product || currentProduct;
        const unit_price_ = editProduct[editProduct.unit_price_key_];
        let realPrice = unit_price_ || editProduct.client_price_;
        const {productPromotion} = promotionInfo[editProduct.id_] || {};
        let min_count_ = editProduct.min_count_;
        let max_count_ = editProduct.max_count_;
        if (min_count_) {
            min_count_ = NP.divide(min_count_, editProduct.number_scale_);
        }
        if (max_count_) {
            max_count_ = NP.divide(max_count_, editProduct.number_scale_);
        }
        editProduct.new_min_count_ = min_count_;
        editProduct.new_max_count_ = max_count_;
        // 订货限制 house_stock_status_：1 正常  2 预售  3 停售
        // 订货限制设置为预售则前端下单不校验库存信息
        // 订货限制设置为停售则前端下单需校验库存信息
        // 此库存校验规则优先级高于全局的库存限制
        if (goods.house_stock_status_ === 1) { // 正常
            if (editProduct.house_enable_stock_ < num && !this.enableStockZero && editProduct.promotionType !== 4) {
                // 库存不足不允许添加
                editProduct.cart_number_ = editProduct.house_enable_stock_ && editProduct.house_enable_stock_ > 0 ? editProduct.house_enable_stock_ : 0;
                message.destroy();
                message.warn(this.intl.messages['KuCunBuZu'] || '库存不足');
            } else {
                editProduct.cart_number_ = +num;
            }
        } else if (goods.house_stock_status_ === 2) { // 预售
            editProduct.cart_number_ = +num;
        } else if (goods.house_stock_status_ === 3) { // 停售
            if (editProduct.house_enable_stock_ < num) {
                // 库存不足不允许添加
                editProduct.cart_number_ = editProduct.house_enable_stock_ && editProduct.house_enable_stock_ > 0 ? editProduct.house_enable_stock_ : 0;
                message.destroy();
                message.warn(this.intl.messages['KuCunBuZu'] || '库存不足');
            } else {
                editProduct.cart_number_ = +num;
            }
        }

        if (editProduct.client_type_min_count_) {
            if (this.enableMinCount && (editProduct.client_type_min_count_ || editProduct.client_type_min_count_ === 0) && editProduct.cart_number_ < editProduct.client_type_min_count_) {
                message.warn(this.intl.messages['DYQDL'] || '低于起订量');
                editProduct.cart_number_ = editProduct.client_type_min_count_;
                return;
            }
        } else {
            if (this.enableMinCount && (editProduct.min_count_ || editProduct.min_count_ === 0) && editProduct.cart_number_ < min_count_) {
                message.warn(this.intl.messages['DYQDL'] || '低于起订量');
                editProduct.cart_number_ = editProduct.min_count_;
                return;
            }
        }
        if (this.enableMaxCount && (editProduct.max_count_ || editProduct.max_count_ === 0) && editProduct.cart_number_ > max_count_) {
            message.warn(this.intl.messages['GYXDL'] || '高于限订量');
            editProduct.cart_number_ = editProduct.max_count_;
            return;
        }

        let usePromotion;
        //基础单位的时候，处理促销
        if (editProduct.unit_id_ === goods.unit_id_ && productPromotion && Object.keys(productPromotion).length) {
            switch (productPromotion.type_) {
                case 1:
                    usePromotion = this.handleGoodsPromotionPresent(editProduct, productPromotion);
                    break;
                case 2:
                case 3:
                    usePromotion = this.handleGoodsPromotionPrice(editProduct, productPromotion);
                    break;
                case 4:
                    usePromotion = productPromotion;
                    break;
            }
        } else {
            realPrice = CommonUtil.priceScale(NP.times((unit_price_ || currentProduct.client_price_), unit_price_ ? 1 : currentProduct.number_scale_));
        }

        if (usePromotion) {
            promotionInfo[editProduct.id_].usePromotion = usePromotion;
            switch (usePromotion.type_) {
                case 1:
                    editProduct.realPrice = realPrice;
                    break;
                case 2:
                    editProduct.realPrice = usePromotion.cut_money_ || usePromotion.cuted_price_;
                    break;
                case 3:
                    editProduct.realPrice = NP.times(realPrice, NP.divide((usePromotion.cut_percent_ || usePromotion.cuted_percent_), 100));
                    break;
            }
        } else {
            if (promotionInfo[editProduct.id_]) {
                promotionInfo[editProduct.id_].usePromotion = {};
            }
            editProduct.realPrice = realPrice;
        }
        const index = addProductList.findIndex(item => item.id_ === editProduct.id_);
        if (editProduct.cart_number_ > 0) {
            if (addProductList.length === 0) {
                editProduct.currentUnit = this.currentUnit;
                addProductList.push(editProduct)
            } else {
                if (index > -1) {
                    addProductList.splice(index, 1, editProduct)
                } else {
                    editProduct.currentUnit = this.currentUnit;
                    addProductList.push(editProduct)
                }
            }
        } else {
            if (index > -1) {
                addProductList.splice(index, 1)
            }
        }

        let totalPrice = 0;
        let totalNumber = 0;
        let total_weight_ = 0;// 运费计算总重量
        let total_cubage_ = 0;// 运费计算总体积
        addProductList.forEach(item => {
            item.totalPrice = NP.times(item.realPrice, item.cart_number_);
            totalNumber = NP.plus(item.cart_number_, totalNumber);
            totalPrice = NP.plus(item.totalPrice, totalPrice);
            if (item.weight_) {
                total_weight_ = NP.plus(total_weight_, NP.times(NP.times(item.weight_, item.number_scale_), item.cart_number_));
            }
            if (item.cubage_) {
                total_cubage_ = NP.plus(total_cubage_, NP.times(NP.times(item.cubage_, item.number_scale_), item.cart_number_));
            }
        });
        this.setState({
            pdList: pdList,
            currentProduct: editProduct,
            totalNumber: totalNumber,
            totalPrice: totalPrice,
            addProductList: addProductList,
            promotionInfo: promotionInfo,
            total_weight_,
            total_cubage_
        })

    };

    //处理买赠的商品促销，获取满足的item
    handleGoodsPromotionPresent = (product, promotion) => {
        if (!promotion) return;
        const itemList = JSON.parse(JSON.stringify(promotion.item_list_));
        const targetPromotion = itemList.sort((itemA, itemB) => itemB.target_number_ - itemA.target_number_).find(item => product.cart_number_ >= item.target_number_);
        if (!targetPromotion) return;
        const index = promotion.item_list_.findIndex(item => targetPromotion.id_ === item.id_);
        targetPromotion.index = index;
        return targetPromotion;
    };
    //处理直降、打折的商品促销，获取满足的item
    handleGoodsPromotionPrice = (product, promotion) => {
        const itemList = JSON.parse(JSON.stringify(promotion.item_list_));
        let targetPromotion;
        if (promotion.is_stair_) {
            targetPromotion = itemList.sort((itemA, itemB) => itemB.target_number_ - itemA.target_number_).find(item => product.cart_number_ >= item.target_number_);
            if (!targetPromotion) return;
            const index = promotion.item_list_.findIndex(item => targetPromotion.id_ === item.id_);
            targetPromotion.index = index;
        } else {
            targetPromotion = promotion;
            targetPromotion.index = 0;
        }
        return targetPromotion;
    };

    // 单位修改
    changeUnit = (unit) => {
        const {currentProduct, addProductList} = this.state;
        if (Object.keys(currentProduct).length === 0) {
            message.info(this.intl.messages['QXZGG'] || '请选择规格！');
            return;
        }
        Object.assign(currentProduct, {
            number_scale_: +unit.scale_,
            unit_id_: +unit.unit_id_,
            unit_name_: unit.unit_name_,
            unit_text_: unit.unit_text_ || unit.unit_name_,
            unit_price_key_: unit.unit_price_key_,
        });

        currentProduct.realPrice = currentProduct[unit.unit_price_key_] || CommonUtil.priceScale(NP.times(currentProduct.client_price_, unit.scale_));
        currentProduct.enableStock = parseInt(NP.divide(currentProduct.house_enable_stock_ || 0, unit.scale_ || 0));
        let min_count_ = currentProduct.min_count_;
        let max_count_ = currentProduct.max_count_;
        if (min_count_) {
            min_count_ = NP.divide(min_count_, currentProduct.number_scale_);
        }
        if (max_count_) {
            max_count_ = NP.divide(max_count_, currentProduct.number_scale_);
        }
        currentProduct.new_min_count_ = min_count_;
        currentProduct.new_max_count_ = max_count_;
        this.setState({
            currentProduct: currentProduct
        }, () => {
            let totalPrice = 0;
            addProductList.forEach(item => {
                item.totalPrice = NP.times(currentProduct[unit.unit_price_key_] || item.realPrice, item.cart_number_);
                totalPrice = NP.plus(item.totalPrice, totalPrice);
            });
            this.setState({
                totalPrice
            }, () => {
                this.forceUpdate();
            })
        })
    };

    addToCart = () => {
        const {addProductList, currentProduct} = this.state;
        if (!this.isLogin) {
            this.props.onCancel();
            RenderUtil.renderLoginModal.call(this.props.intl);
            return;
        }
        if (!currentProduct.id_) {
            message.info(this.intl.messages['QXZGG'] || '请选择规格！');
            return;
        }
        if (addProductList.length === 0 && currentProduct.id_) {
            message.info(this.intl.messages['SPSLYW'] || '商品数量有误！');
            return;
        }
        const params = [];
        addProductList.forEach(product => {
            params.push({
                goods_id_: product.goods_id_,
                product_id_: product.id_,
                unit_id_: product.unit_id_,
                number_: product.cart_number_,
            });
        });
        params.forEach(param => {
            const oldParam = this.cartParams.findIndex(item => item.product_id_ === param.product_id_);
            if (oldParam > -1) {
                this.cartParams.splice(oldParam, 1, param);
            } else {
                this.cartParams.push(param);
            }
            clearTimeout(this.cartTimer);
            this.cartTimer = setTimeout(this.batchModifyCart, 300);
        });
    };

    batchModifyCart = () => {
        if (this.cartParams.length) {
            message.destroy();
            message.loading((this.intl.messages['ZhengZaiChuLi...'] || '正在处理...'));
            CartFetch.batchModify(this.cartParams).then(rs => {
                message.destroy();
                if (rs.status === 1) {
                    message.success((this.intl.messages['JRGWCCG'] || '加入购物车成功'));
                    this.cartParams = [];
                    InitUtil.getCartNumber();
                    this.onCancel();
                } else if (rs.status === 403) {
                    // 403重复提交后重试
                    setTimeout(this.batchModifyCart, 100);
                    message.error('操作频繁，正在重新尝试...');
                } else {
                    message.error(rs.message);
                }
            });
        }
    };

    onCancel = () => {
        this.setState({
            goods: {},
            currentProduct: {},
            addProductList: [],
            isShowAddProductList: false,
        });
        this.props.onCancel();
    };

    getPrice = () => {
        const {goods, currentProduct, promotionInfo} = this.state;
        if (Object.keys(goods).length) {
            let priceText = '';
            if (this.allowClientPrice && !this.isLogin) {
                priceText = (this.intl.messages['QDLCKJG'] || '请登录查看价格');
                return priceText
            } else {
                if (currentProduct.id_) {
                    const {productPromotion} = promotionInfo[currentProduct.id_] || {};
                    if (currentProduct.unit_id_ === goods.unit_id_ && productPromotion &&
                        !productPromotion.is_stair_ && (productPromotion.type_ === 2 || productPromotion.type_ === 3)) {
                        switch (productPromotion.type_) {
                            case 2:
                                currentProduct.realPrice = productPromotion.cuted_price_;
                                break;
                            case 3:
                                currentProduct.realPrice = NP.times(currentProduct.client_price_, (productPromotion.cuted_percent_ / 100));
                                break;
                            // no default
                        }
                    }
                    if (goods.is_multi_unit_) { // 应用等级价
                        const targetIndex = goods.mult_unit_.findIndex((item) => item.unit_id_ === currentProduct.unit_id_);
                        if (targetIndex === 1) {
                            if (currentProduct.unit_price_) {
                                currentProduct.realPrice = currentProduct.unit_price_
                            }
                        } else if (targetIndex === 2) {
                            if (currentProduct.unit2_price_) {
                                currentProduct.realPrice = currentProduct.unit2_price_
                            }
                        }
                    }
                    priceText = `${this.currencySymbol}${CommonUtil.priceScale(currentProduct.realPrice)}`;
                    return priceText;
                }
                if (goods.productList && goods.productList.length > 1) {
                    const priceArr = [];
                    goods.productList.forEach(item => {
                        const productPromotion = promotionInfo[item.id_];
                        const promotion = productPromotion ? productPromotion.productPromotion : {};
                        let tmpPrice = item.client_price_;
                        if (promotion && !promotion.is_stair_) {
                            if (promotion.cuted_price_) {
                                tmpPrice = promotion.cuted_price_
                            }
                            if (promotion.cuted_percent_) {
                                tmpPrice = NP.times(promotion.cuted_percent_ / 100, item.client_price_)
                            }
                        }
                        priceArr.push(tmpPrice)
                    });
                    const minPrice_ = Math.min(...priceArr);
                    const maxPrice_ = Math.max(...priceArr);
                    priceText = maxPrice_ === minPrice_ ? `${this.currencySymbol}${CommonUtil.priceScale(minPrice_)}` : `${this.currencySymbol}${CommonUtil.priceScale(minPrice_)} - ${this.currencySymbol}${CommonUtil.priceScale(maxPrice_)}`;
                    return priceText;
                }
                priceText = `${this.currencySymbol}${CommonUtil.priceScale(goods.client_price_)}`;
            }
            return priceText
        }
        return "";
    };

    toGoodsList = (promotion) => {
        this.props.history.push({
            pathname: '/goods/list',
            state: {goods_activity_id_: promotion.goods_promotion_activity_id_, from: 'goods'}
        })
    };

    // 判断是否有当前组合规格
    notHaveSpecs(id, v) {
        const {specsValue, goods} = this.state;
        //已选同类型
        if (specsValue[id]) {
            let notSpecs = true;
            let outerSpecs = [];
            // 排除已选的同级选项
            for (let key in specsValue) {
                if (parseInt(key) !== id) {
                    outerSpecs.push(specsValue[key]);
                }
            }
            goods.productList.forEach(product => {
                let format = [product.spec_value_, product.spec_value2_, product.spec_value3_, product.spec_value4_, product.spec_value5_];
                // 规格是否包含已选的同类值
                let hasSameSpecs = true;
                outerSpecs.forEach(spec => {

                    if (!format.includes(spec)) {
                        hasSameSpecs = false;
                    }
                });
                // 规格包含已选值和当前值
                if (hasSameSpecs && format.includes(v)) {
                    notSpecs = false;
                }
            });
            return notSpecs;
        } else {
            let notSpecs = true;
            let specsArr = [];
            for (let key in specsValue) {
                specsArr.push(specsValue[key])
            }
            goods.productList.forEach(product => {
                let format = [product.spec_value_, product.spec_value2_, product.spec_value3_, product.spec_value4_, product.spec_value5_];
                // 规格是否包含已选值
                let hasSelectSpecs = true;
                specsArr.forEach(spec => {
                    if (!format.includes(spec)) {
                        hasSelectSpecs = false
                    }
                });
                // 规格包含已选值且包含当前值
                if (hasSelectSpecs && format.includes(v)) {
                    notSpecs = false;
                }
            });
            return notSpecs

        }

    }

    renderPromotionInfo = (promotion) => {
        let renderItem = [];
        switch (promotion.type_) {
            case 1:
                promotion.item_list_.forEach(item => {
                    renderItem.push(
                        <div key={item.id_} className={'promotion-item'}>
                            <span>
                                {
                                    this.intl.M1JZ1J ?
                                        this.intl.formatMessage({
                                            id: `M1JZ1J`
                                        }, {
                                            num: item.target_number_,
                                            presentNum: item.present_number_
                                        }) : `满${item.target_number_}件赠${item.present_number_}件`
                                }

                                </span>
                            <span className={'img-box'} role={'none'} onClick={() => this.toGoodsDetail(item)}><ImgAdapt
                                src={item.present_product_img_ || item.present_goods_img_ || IMG_Default}/></span>
                            <span className={'high'}>×{item.present_number_}</span>
                        </div>
                    )
                });
                break;
            case 2:
                if (promotion.is_stair_) {
                    promotion.item_list_.forEach(item => {
                        renderItem.push(
                            <div key={item.id_} className={'promotion-item'}>
                                <span>
                                    {
                                        this.intl._M1JLXMJ1Y_ ?
                                            this.intl.formatMessage({
                                                id: `_M1JLXMJ1Y_`
                                            }, {
                                                num: item.target_number_,
                                                price: item.cut_money_
                                            })
                                            :
                                            `【满${item.target_number_}件立享每件${item.cut_money_}元】`
                                    }
                                </span>
                            </div>
                        )
                    });
                } else {
                    renderItem.push(
                        <div className={'promotion-item'} key={promotion.id_}>
                            <span>
                            {
                                this.intl._DHJJZ1Y_ ?
                                    this.intl.formatMessage({
                                        id: `_DHJJZ1Y_`
                                    }, {
                                        price: promotion.cuted_price_
                                    })
                                    :
                                    `订货价降至${promotion.cuted_price_}元`
                            }
                            </span>
                        </div>
                    )
                }
                break;
            case 3:
                if (promotion.is_stair_) {
                    promotion.item_list_.forEach(item => {
                        renderItem.push(
                            <div key={item.id_} className={'promotion-item'}>
                                <span>
                                    {
                                        this.intl._M1JLXMJ1Z_ ?
                                            this.intl.formatMessage({
                                                id: `_M1JLXMJ1Z_`
                                            }, {
                                                num: item.target_number_,
                                                discount: item.cut_percent_
                                            })
                                            :
                                            `【满${item.target_number_}件立享每件打${item.cut_percent_ / 10}折】`
                                    }
                                </span>
                            </div>
                        )
                    });
                } else {
                    renderItem.push(
                        <div className={'promotion-item'}>
                            <span>
                                {
                                    this.intl._YDHJD1Z_ ?
                                        this.intl.formatMessage({
                                            id: `_YDHJD1Z_`
                                        }, {
                                            discount: promotion.cuted_percent_ / 10
                                        })
                                        :
                                        `【原订货价打${promotion.cuted_percent_ / 10}折】`
                                }
                            </span>
                        </div>
                    )
                }
                break;
        }
        return renderItem
    };

    selectProduct = (product) => {
        const {goods} = this.state;
        console.log('this.maxUnit：', this.maxUnit)
        console.log('goods：', goods)
        console.log('orderDefaultUnit：', this.orderDefaultUnit)
        this.setState({
            currentProduct: product,
        }, () => {
            if (this.orderDefaultUnit === 2 && goods.is_multi_unit_) {
                this.changeUnit(this.maxUnit);
            } else {
                this.changeUnit(this.currentUnit);
            }
            this.forceUpdate();
        });
    };

    // 选取组合规格
    selectSpecs(specLvl, key, v) {
        let {specsValue, specsValueLvl, goods} = this.state;
        let specsArr = [];
        let currentSpec = {};
        let currentSpecIndex = -1;
        // 判断点击规格是否已选
        if (specsValue[key] === v) {
            delete specsValue[key];
        } else {
            specsValue[key] = v;
        }
        // 判断点击规格是否已选
        if (specsValueLvl[specLvl] === v) {
            delete specsValueLvl[specLvl];
        } else {
            specsValueLvl[specLvl] = v;
        }
        // 匹配对应规格
        specsArr = Object.values(specsValue);
        let specsLvlArr = Object.values(specsValueLvl);
        if (specsArr.length === goods.spec_setting_.settings_.length) {
            goods.productList.forEach((product, index) => {
                let hsaProduct = true;
                let format = [product.spec_value_];
                if (product.spec_value2_) {
                    format.push(product.spec_value2_);
                }
                if (product.spec_value3_) {
                    format.push(product.spec_value3_);
                }
                if (product.spec_value4_) {
                    format.push(product.spec_value4_);
                }
                if (product.spec_value5_) {
                    format.push(product.spec_value5_);
                }
                inside1:for (let i = 0, j = specsLvlArr.length; i < j; i++) {
                    if (format[i] != (specsLvlArr[i])) {
                        hsaProduct = false;
                        break inside1;
                    }
                }
                if (!hsaProduct) {
                    hsaProduct = true;
                    format.reverse();
                    inside2:for (let i = 0, j = specsLvlArr.length; i < j; i++) {
                        if (format[i] != (specsLvlArr[i])) {
                            hsaProduct = false;
                            break inside2;
                        }
                    }
                }

                if (hsaProduct) {
                    currentSpec = product;
                    currentSpecIndex = index;
                }
            });
        }

        this.setState({
            specsValue: specsValue,
            specsValueLvl: specsValueLvl,
        });
        this.selectProduct(currentSpec);
    };

    toggleAddressList = () => {
        this.setState({
            isShowAddProductList: !this.state.isShowAddProductList
        })
    };

    reserveNow = () => {
        const {goods, addProductList, promotionInfo, currentProduct} = this.state;
        if (Object.keys(currentProduct).length === 0) {
            message.info(this.intl.messages['QXZGG'] || '请选择规格！');
            return;
        }
        if (Object.keys(currentProduct).length > 0 && addProductList.length === 0) {
            message.info(this.intl.messages['SPSLYW'] || '商品数量有误！');
            return;
        }
        const product = addProductList.find(item => item.promotionType === 4);
        const {usePromotion} = promotionInfo[product.id_] || {};
        if (product.cart_number_ === 0) {
            message.info(this.intl.messages['SPSLYW'] || '商品数量有误！');
            return;
        }
        if (usePromotion && (usePromotion.min_count_ || usePromotion.min_count_ === 0) && usePromotion.min_count_ > product.cart_number_) {
            message.info(
                this.intl.formatMessage({
                    id: 'ShangPin1QiShou'
                }, {num: usePromotion.min_count_}));
            // `商品${usePromotion.min_count_}起售`);
            return;
        }
        if (usePromotion && (usePromotion.max_count_ || usePromotion.max_count_ === 0) && usePromotion.max_count_ < product.cart_number_) {
            message.info(
                this.intl.formatMessage({
                    id: 'SPDGSLBNCG'
                }, {num: usePromotion.max_count_}));
            return;
        }
        this.props.onCancel();
        const newGoods = JSON.parse(JSON.stringify(goods));
        newGoods.productList = addProductList;
        this.props.history.push({
            pathname: '/order/create',
            state: {pdList: [newGoods], promotionInfo, isPresale: true, expect_time_: usePromotion.expect_time_}
        })
    };

    isDisabled = (product) => {
        const {goods} = this.state;
        let flag = product.house_enable_stock_ <= 0 && !this.enableStockZero;
        if (goods.house_stock_status_ === 2) { // 预售商品
            flag = false;
        }
        return flag;
    };

    render() {
        const {
            goods,
            currentProduct,
            promotionInfo,
            specsValue = {},
            isShowAddProductList,
            addProductList,
            totalPrice = 0,
            totalNumber = 0,
            total_weight_,
            total_cubage_
        } = this.state;
        const {visible, onCancel} = this.props;
        const {productPromotion} = promotionInfo[currentProduct.id_] || {};
        const dateTime = productPromotion ? CommonUtil.timeTranslate(productPromotion.remaining_time_) : undefined;
        const overlay = <Menu>
            {
                (goods.mult_unit_ || []).map(unit => {
                    return <Menu.Item
                        onClick={() => this.changeUnit(unit)}
                        key={unit.unit_id_}>
                        {+unit.scale_ === 1 ? unit.unit_name_ : unit.unit_text_}
                    </Menu.Item>
                })
            }
        </Menu>;

        const buyBtnStyle = {
            backgroundColor: CommonUtil.colorRgb('#' + this.companyTheme, 12),
        };
        return (
            <Modal
                centered
                destroyOnClose
                wrapClassName="page-custom-modal goods-modal-box"
                visible={visible}
                width={760}
                footer={null}
                onCancel={onCancel}
            >
                <div className="goods-modal-row">
                    <div className="image-box">
                        <ImgAdapt src={goods.main_img_ ? `${goods.main_img_}_200` : IMG_Default}/>
                    </div>
                    <div className="detail-box">
                        <h3 className="name">{goods.name_}</h3>
                        {
                            currentProduct.id_ ? (
                                <p className="tips" title={goods.name_}>{this.intl.messages['GuiGeBianHao'] || '规格编号'}：{currentProduct.code_}</p>
                            ) : (
                                <p className="tips" title={goods.name_}>{this.intl.messages['ShangPinBianHao'] || '商品编号'}：{goods.code_}</p>
                            )
                        }
                        {
                            (currentProduct.market_price_) &&
                            <div className="price-row">
                                <div className="title">{this.intl.messages['LingShouJia'] || '零售价'}</div>
                                <div className="market-price"><span
                                    className={'line-through'}>{this.currencySymbol}{CommonUtil.priceScale(currentProduct.market_price_)}</span>
                                </div>
                            </div> || null
                        }
                        <div className="price-row">
                            <div className="title">{this.intl.messages['YouHuiJia'] || '优惠价'}</div>
                            <div className="price"><span className="txt-hint">{this.getPrice()}</span></div>
                        </div>
                        {
                            productPromotion && productPromotion.type_ === 4 &&
                            <div className="price-row promotion-row">
                                <div className="title">{this.intl.messages['YuShou'] || '预售'}</div>
                                <div className="price">
                                    <div className={'tag-box'}><Tag
                                        color="#FF3838">{this.intl.messages['YuShou'] || '预售'}</Tag></div>
                                    <div className={'info-box'}>
                                        <p>
                                            {this.intl.messages['YuJi'] || '预计'}
                                            {CommonUtil.formatTime(productPromotion.expect_time_, (`${this.intl.messages['MMYDDR']} hh: mm` || `MM月DD日 hh: mm`))}{this.intl.messages['KaiShiFaHuo'] || '开始发货'}</p>
                                        {
                                            dateTime &&
                                            <p className={'txt-hint'}>
                                                {
                                                    this.intl.messages.JHDJSHS_1T ? (
                                                        this.intl.formatMessage({
                                                            id: 'JHDJSHS_1T',
                                                        }, {
                                                            d: dateTime.d,
                                                            h: dateTime.h,
                                                            m: dateTime.m,
                                                            s: dateTime.s
                                                        })
                                                    ) : (
                                                        `距活动结束还剩：${dateTime.d}天${dateTime.h}时${dateTime.m}分${dateTime.s}秒`
                                                    )

                                                }

                                            </p>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            productPromotion && productPromotion.type_ !== 4 &&
                            <div className="price-row promotion-row">
                                <div
                                    className="title">{productPromotion.goods_promotion_activity_title_}</div>
                                <div className="price">
                                    <div className={'tag-box'}><Tag
                                        color="#FF3838">{this.intl.messages[DataConstant.goodsPromotion.type[productPromotion.type_]]}</Tag>
                                    </div>
                                    <div className={'info-box'}>
                                        <div>{this.renderPromotionInfo(productPromotion)}</div>
                                        {
                                            dateTime &&
                                            <p className={'txt-hint'}>
                                                {
                                                    this.intl.messages.JHDJSHS_1T ? (
                                                        this.intl.formatMessage({
                                                            id: 'JHDJSHS_1T',
                                                        }, {
                                                            d: dateTime.d,
                                                            h: dateTime.h,
                                                            m: dateTime.m,
                                                            s: dateTime.s
                                                        })
                                                    ) : (
                                                        `距活动结束还剩：${dateTime.d}天${dateTime.h}时${dateTime.m}分${dateTime.s}秒`
                                                    )

                                                }
                                            </p>
                                        }
                                    </div>
                                    <div className={'more'} role={'none'}
                                         onClick={() => this.toGoodsList(productPromotion)}>{this.intl.messages['ChaKanXiangQing'] || '查看详情'} >>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="current-product-row">
                            {currentProduct.format_ ? ` ${this.intl.messages['YiXuan'] || '已选'}：${currentProduct.format_}` : this.intl.messages['QXZGG'] || '请选择规格'}
                        </div>
                    </div>
                </div>

                {
                    goods.is_multi_spec_ ?
                        <Fragment>
                            {
                                goods.spec_setting_ &&
                                goods.spec_setting_.settings_.map((spec, index) => {
                                    return <div className="product-wrap" key={spec.id_}>
                                        <div className="title">{spec.name_}</div>
                                        <div className="product-main">
                                            {
                                                spec.values_.map((v, specIndex) => {
                                                    const cls = classnames('product-item', {
                                                        'active': specsValue[spec.id_] === v
                                                    });
                                                    return <button
                                                        key={`${spec.id_}-${specIndex}`}
                                                        disabled={this.notHaveSpecs(spec.id_, v)}
                                                        className={cls}
                                                        onClick={() => this.selectSpecs(index, spec.id_, v)}>
                                                        {v}
                                                    </button>
                                                })
                                            }
                                        </div>
                                    </div>
                                })
                            }
                        </Fragment> :
                        <div className="product-wrap">
                            <div className="title">{this.intl.messages['GuiGe'] || '规格'}</div>
                            <div className="product-main">
                                <Scrollbars autoHeight autoHeightMax={350}>
                                    {
                                        (goods.productList || []).map(product => {
                                            return (
                                                <span
                                                    className={`product-item ${currentProduct.id_ === product.id_ ? 'active' : ''}`}
                                                    role={'none'} key={product.id_}
                                                    onClick={() => this.selectProduct(product)}>
                                                            {product.format_}
                                                        </span>
                                            )
                                        })
                                    }

                                </Scrollbars>
                            </div>
                        </div>

                }

                <div className="product-info-wrap">
                    <div className={`cart-list-row ${isShowAddProductList ? 'dis-show' : ''}`}>
                        <Scrollbars autoHeight autoHeightMax={350}>
                            {
                                addProductList.map(item => {
                                    return (
                                        <div className="product-info-row" key={item.id_}>
                                            <div
                                                className="format-wrap">{item.format_ || (this.intl.messages['QXZGG'] || '请选择规格')}</div>
                                            <div
                                                className="price-wrap">
                                                {item.realPrice ? `${this.currencySymbol}${CommonUtil.priceScale(item.realPrice)}` : `${this.currencySymbol} - -`}
                                            </div>
                                            <div className="unit-wrap">
                                                {
                                                    !!goods.is_multi_unit_ ? (
                                                        <Dropdown overlay={overlay} trigger={['click']}>
                                                            <div>
                                                                {
                                                                    item.currentUnit.unit_name_
                                                                }
                                                                <DownOutlined/>
                                                            </div>
                                                        </Dropdown>
                                                    ) : (
                                                        <span>{item.unit_text_}</span>
                                                    )
                                                }
                                            </div>
                                            <div
                                                className="stock-wrap">{CommonUtil.getStockText(item.enableStock || 0, undefined, this.intl)}</div>
                                            <div className="number-wrap">
                                                <InputNumber
                                                    size="small"
                                                    value={item.cart_number_}
                                                    disabled={this.isDisabled(item)}
                                                    onChange={(num) => this.changeNumber(num, item)}
                                                    min={this.enableMinCount ? (item.client_type_min_count_ || item.new_min_count_ || item.min_count_ || this.inputNumberMin) : this.inputNumberMin}
                                                    max={this.enableMaxCount ? (item.new_max_count_ || item.max_count_ || Infinity) : Infinity}
                                                    precision={+this.countScale}
                                                    setp={this.inputNumberMin}
                                                />
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </Scrollbars>
                    </div>
                    <div className={`product-num-row ${addProductList.length > 0 ? 'dis-flex' : ''}`}>
                        <div className="number-total-wrap">{this.intl.messages['SLHJ'] || '数量合计'}：{totalNumber}</div>
                        <div className="price-total-wrap">{this.intl.messages['JEHJ'] || '金额合计'}：{this.currencySymbol}{CommonUtil.priceScale(totalPrice)}</div>
                        {
                            this.clientShowCubage &&
                            <div style={{marginRight: '60px'}}>{this.intl.messages['ZongTiJi'] || '体积合计'}：{total_cubage_}(m³)</div> || null
                        }
                        <div className="detail-btn" role={'none'}
                             onClick={this.toggleAddressList}>{this.intl.messages['ShangPinQingDan'] || '商品清单'}
                            <i className={`iconfont ${isShowAddProductList ? `icon-open-n-2` : `icon-open-s-2`}`}/>
                        </div>
                    </div>
                    <div className="product-info-row">
                        <div
                            className="format-wrap">{currentProduct.format_ || (this.intl.messages['QXZGG'] || '请选择规格')}</div>
                        <div
                            className="price-wrap">{currentProduct.realPrice ? `${this.getPrice()}` : `${this.currencySymbol}- -`}</div>
                        <div className="unit-wrap">
                            {
                                !!goods.is_multi_unit_ ? (
                                    <Dropdown overlay={overlay} trigger={['click']}>
                                        <div>{currentProduct.unit_text_ || goods.unit_name_}
                                            <DownOutlined/></div>
                                    </Dropdown>
                                ) : (
                                    <span>{currentProduct.unit_text_ || goods.unit_name_}</span>
                                )
                            }
                        </div>
                        <div className="stock-wrap">
                            {CommonUtil.getStockText((currentProduct.id_ ? currentProduct.enableStock : goods.house_enable_stock_), undefined, this.intl)}
                        </div>
                        <div className="quantity">
                            {
                                (currentProduct.client_type_min_count_ || currentProduct.min_count_) && this.enableMinCount ? `${this.intl.messages['QiDingLiang']}：${currentProduct.client_type_min_count_ || currentProduct.new_min_count_ || currentProduct.min_count_}` : null
                            }
                            {(currentProduct.client_type_min_count_ || currentProduct.min_count_) && currentProduct.max_count_ && this.enableMinCount && this.enableMaxCount ? `，` : ``}
                            {
                                currentProduct.max_count_ && this.enableMaxCount ? `${this.intl.messages['XianDingLiang']}：${currentProduct.new_max_count_ || currentProduct.max_count_}` : null
                            }
                        </div>
                        <div className="number-wrap">
                            <InputNumber
                                size="small"
                                min={this.enableMinCount ? (currentProduct.client_type_min_count_ || currentProduct.new_min_count_ || currentProduct.min_count_ || 0) : 0}
                                max={this.enableMaxCount ? (currentProduct.new_max_count_ || currentProduct.max_count_ || Infinity) : Infinity}
                                precision={+this.countScale}
                                setp={this.inputNumberMin}
                                value={currentProduct.cart_number_ || 0}
                                disabled={this.isDisabled(currentProduct)}
                                onChange={(num) => this.changeNumber(num)}
                            />
                        </div>
                    </div>
                    <div className="btn-wrap">
                        {
                            currentProduct.promotionType === 4 ? (
                                <button className="buy-btn" onClick={this.reserveNow}
                                        style={buyBtnStyle}>{this.intl.messages['LiJiYuDing'] || '立即预定'}</button>
                            ) : (
                                <button className="add-btn" onClick={this.addToCart}>{this.intl.messages['JRGWC'] || '加入购物车'}</button>
                            )
                        }

                    </div>
                </div>
            </Modal>
        )
    }
}

export default GoodsListAction;
